import { ENV } from "../utils";

export class EnergyPerformanceInstallationform {
  baseApi = ENV.BASE_API;

  async getEnergyPerformanceInstallation(accessToken, id) {
    try {
      const url = `${this.baseApi}/energy-performance/${id}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createEnergyPerformanceInstallation(accessToken, data) {
    try {
      const url = `${this.baseApi}/add-energy-performance`;
      const params = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateEnergyPerformanceInstallation(accessToken, id, data) {
    try {
      const url = `${this.baseApi}/energy-performance/${id}`;
      const params = {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteEnergyPerformanceInstallation(accessToken, id) {
    try {
      const url = `${this.baseApi}/delete-energy-performance/${id}`;
      const params = { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getEnergyPerformanceInstallationsBySite(accessToken, site) {
    try {
      const url = `${this.baseApi}/energy-performance-site/${site}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  // data = FormData con un campo "files" (el archivo de evidencia)
  async uploadEvidence(accessToken, data) {
    try {
      const url = `${this.baseApi}/energy-performance/upload-evidence`;
      const params = {
        method: "POST",
        body: data,
        headers: { Authorization: `Bearer ${accessToken}` },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteEvidence(accessToken, fileName) {
    try {
      const url = `${this.baseApi}/energy-performance/delete-evidence`;
      const params = {
        method: "DELETE",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify({ fileName }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  getEvidenceUrl(fileName) {
    return `${this.baseApi}/energy-performance/evidence/${fileName}`;
  }

  // Importación (hoja 19): data = FormData con "file" (.json, .csv o .xlsx) y "site".
  // preview no guarda: devuelve { ok, errors, preview, target }. confirm guarda: { installation } o errors.
  async previewImport(accessToken, data) {
    return this._send(`${this.baseApi}/energy-performance-import/preview`, accessToken, { method: "POST", body: data });
  }

  async confirmImport(accessToken, data) {
    return this._send(`${this.baseApi}/energy-performance-import/confirm`, accessToken, { method: "POST", body: data });
  }

  // Versiones de la línea de base (6.5): { from, to, reason } y { adopt, reason }
  async registerBaselinePeriod(accessToken, id, data) {
    return this._send(`${this.baseApi}/energy-performance/${id}/baseline-period`, accessToken, { method: "POST", json: data });
  }

  async registerBaselineModel(accessToken, id, data) {
    return this._send(`${this.baseApi}/energy-performance/${id}/baseline-model`, accessToken, { method: "POST", json: data });
  }

  // La instalación en el formato de intercambio sustemia.energia.v2
  async getV2(accessToken, id) {
    return this._send(`${this.baseApi}/energy-performance/${id}/v2`, accessToken, {});
  }

  // Ejemplos (globales, solo lectura), copias para practicar y «Restablecer»
  async getExamples(accessToken) {
    return this._send(`${this.baseApi}/energy-performance-examples`, accessToken, {});
  }

  async getExample(accessToken, id) {
    return this._send(`${this.baseApi}/energy-performance-examples/${encodeURIComponent(id)}`, accessToken, {});
  }

  async createPractice(accessToken, id, site) {
    return this._send(`${this.baseApi}/energy-performance-examples/${encodeURIComponent(id)}/practice`, accessToken, { method: "POST", json: { site } });
  }

  async getPracticeBySite(accessToken, site) {
    return this._send(`${this.baseApi}/energy-performance-site/${site}/practice`, accessToken, {});
  }

  async resetInstallation(accessToken, id) {
    return this._send(`${this.baseApi}/energy-performance/${id}/reset`, accessToken, { method: "POST", json: {} });
  }

  async _send(url, accessToken, { method = "GET", body, json }) {
    const headers = { Authorization: `Bearer ${accessToken}` };
    if (json !== undefined) headers["Content-Type"] = "application/json";
    const response = await fetch(url, { method, headers, body: json !== undefined ? JSON.stringify(json) : body });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
